import React from 'react';
import { Button, Modal, ModalContent } from '../common';
import { Heading, Text } from '../common/Typography';

const CancelSignupModal = ({
  isOpen,
  onClose,
  onConfirm,
  sessionName,
  userSignupStatus,
  isLoading = false,
}) => {
  const isOnWaitlist = userSignupStatus?.signup_status === 'waitlist';
  const waitlistPosition = userSignupStatus?.waitlist_position;

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!isLoading}>
      <ModalContent size="small" constrainHeight={false} className="text-center">
        <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-danger-light mb-4">
          <svg className="h-6 w-6 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <Heading level={3} className="text-text-primary mb-2">
          Cancel Signup
        </Heading>
        <Text className="text-text-secondary mb-4">
          Are you sure you want to cancel your signup for <strong>{sessionName}</strong>?
        </Text>
        <Text className="text-text-secondary text-sm mb-6">
          {isOnWaitlist
            ? `You will be removed from the waitlist and lose your position #${waitlistPosition}.`
            : 'Your spot will be given to the next person on the waitlist (if any).'}
        </Text>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-center sm:gap-3">
          <Button onClick={onClose} variant="outline" disabled={isLoading} className="w-full sm:w-auto">
            Keep Signup
          </Button>
          <Button onClick={onConfirm} variant="danger" disabled={isLoading} className="w-full sm:w-auto">
            {isLoading ? 'Cancelling...' : 'Yes, Cancel Signup'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default CancelSignupModal;
